// extracted by mini-css-extract-plugin
module.exports = {"inner":"AuthorSummary_inner__WVc_3","image":"AuthorSummary_image__GJinQ","text":"AuthorSummary_text__82hvf"};